import { inject, Injectable } from "@angular/core";
import { MCFieldSchema, MCFieldSchemaService, MCPropertyValue, MCSchemaProperties, MCSectionSchema } from "@maslul/common-services";
import { ProductsStoreService } from "../store/products";
import { Guid } from "guid-typescript";
import { TABS } from "../../enum/request/TABS";
import { MIHttpWrapperService } from "../shared/mi-http-wrapper.service";
import { MIUnionRequestHttpService } from "../shared/union-request-http";

@Injectable({ providedIn: 'root' })
export class SchemaService extends MCFieldSchemaService {

    private productsStore = inject(ProductsStoreService);
    private httpService = inject(MIUnionRequestHttpService);


    constructor() {
        super();
    }

    //לא בתוך טבלה
    updateFielsSchema(sectionsSchema: MCSectionSchema[], fieldName: string, propertiesValueToUpdate: MCPropertyValue[]) {
        sectionsSchema.forEach((sectionSchema: MCSectionSchema) => {
            sectionSchema.fieldsSchema.forEach((fieldSchema: MCFieldSchema) => {
                if (fieldSchema.name === fieldName) {
                    propertiesValueToUpdate.forEach((prop: MCPropertyValue) => {
                        fieldSchema[prop.propertyName] = prop.value;
                    })
                }
            })
        });
    }

    override addFieldSchema(schemaProperties: MCSchemaProperties): void {
        // MI לא שולח לשרת - עדכון מקומי בלבד
    }

    override deleteFieldSchema(schemaProperties: MCSchemaProperties, functionName?: any): void {
        // MI לא שולח לשרת - עדכון מקומי בלבד
    }



    updateFieldSchema(fieldName: string, productGuid: Guid, properties: any, tab: TABS) {

        this.httpService.updateFieldSchema({});
    }
}
